module.exports = __webpack_public_path__ + "img/May.dfccac72.png";